import { useContext } from 'react'
import { ISeo } from '../types'

// TODO: Remove component
export const Seo = (props: { metaData: ISeo }) => {
  return null
}
